<template>
  <div class="loginContainer">
    <div class="loginContent" @click="showSelect = false">
      <img :src="cancel" alt="" class="pointer" @click="close">
      <div class="title" v-if="$store.state.loginStatus==='login'">{{$t('lang.login.login')}}</div>
      <div class="title" v-if="$store.state.loginStatus==='register'">{{$t('lang.login.register')}}</div>
      <div class="title" v-if="$store.state.loginStatus==='forget'">{{$t('lang.login.recover')}}</div>
      <div class="title" v-if="$store.state.loginStatus==='reset'">{{$t('lang.login.reset')}}</div>
      <div class="body" v-if="$store.state.loginStatus==='login'">
        <div class="text1 mb15">{{$t('lang.login.email')}}</div>
        <div class="inputRow">
          <input v-model="email"/>
        </div>
        <div class="text1 mb15 mt15">{{$t('lang.login.password')}}</div>
        <div class="inputRow">
          <input v-model="password" type="password"/>
        </div>
        <div class="mt15 fg-login-option">
          <div class="prompt">
            <span>{{$t('lang.login.continue')}}</span>
          </div>
          <div class="login-option" style="margin: 0">
            <div class="login-option-item pointer" style="background: #4E6297; margin-right: 10px"
                 @click="loginWithFacebook">
              <img :src="facebook">
            </div>
            <div class="login-option-item pointer" style="background: #C5331E; margin-left: 10px"
                 @click="loginWithGoogle">
              <img :src="google">
            </div>
          </div>
        </div>
        <div class="mt15 footer-operation">
          <div class="operation-item pointer" @click="setLoginStatus('register')">
            <span>{{$t('lang.login.register')}}</span>
          </div>
          <div class="splitter"></div>
          <div class="operation-item pointer" @click="setLoginStatus('forget')">
            <span>{{$t('lang.login.forget')}}</span>
          </div>
        </div>
      </div>
      <div class="body" v-if="$store.state.loginStatus==='register'">
        <div class="text1 mb15">
          {{$t('lang.login.email')}}
        </div>
        <div class="inputRow">
          <input v-model="email"/>
        </div>
        <div class="text1 mb15 mt15">
          {{$t('lang.login.username')}}
        </div>
        <div class="inputRow">
          <input v-model="userName"/>
        </div>
        <div class="text1 mb15 mt15">
          {{$t('lang.login.password')}}
        </div>
        <div class="inputRow">
          <input v-model="password" type="password"/>
        </div>
        <div class="text1 mb15 mt15">
          {{$t('lang.common.currency')}}
        </div>
        <div class="inputRow">
          <div class="select pointer">
            <div/>
            <div class="input" @click.stop="showSelect = !showSelect">{{currency}} {{fetchCurrency[currency]}}</div>
            <img :src="triangle" :class="{rotate: showSelect}" alt="">
            <div class="selectList" v-show="showSelect">
              <div class="option pointer" v-for="(item, index) in currencyList" :key="index" @click="select('currency', item.value)">{{item.label}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="body" v-if="$store.state.loginStatus==='forget'">
        <div class="text1 mb15">{{$t('lang.login.email')}}</div>
        <div class="inputRow">
          <input v-model="email"/>
        </div>
      </div>
      <div class="body" v-if="$store.state.loginStatus==='reset'">
        <div class="text1 mb15">{{$t('lang.login.password')}}</div>
        <div class="inputRow">
          <input v-model="password" type="password"/>
        </div>
      </div>
      <div class="body" v-if="$store.state.loginStatus === 'registerGoogle'">
        <div class="text1 mb15">
          {{$t('lang.login.Username')}}
        </div>
        <div class="inputRow">
          <label>
            <input type="text" v-model="userName">
          </label>
          <div class="err" v-if="showErr">
            {{$t('lang.login.invalid')}}
          </div>
        </div>
        <div class="text1 mb15 mt15">
          {{$t('lang.login.depositCur')}}
        </div>
        <div class="inputRow">
          <label>
            <input class="selectInput" type="text" :value="`${currency} ${fetchCurrency[currency]}`" readonly>
          </label>
        </div>
      </div>
      <div class="body" v-if="$store.state.loginStatus === 'registerFacebook'">
        <div class="text1 mb15">
          {{$t('lang.login.Username')}}
        </div>
        <div class="inputRow">
          <label>
            <input type="text" v-model="userName">
          </label>
          <div class="err" v-if="showErr">
            {{$t('lang.login.invalid')}}
          </div>
        </div>
        <div class="text1 mb15 mt15">
          {{$t('lang.login.depositCur')}}
        </div>
        <div class="inputRow">
          <label>
            <input class="selectInput" type="text" :value="`${currency} ${fetchCurrency[currency]}`" readonly>
          </label>
        </div>
      </div>
      <div>
        <div class="submit pointer" @click="handleSubmit" v-if="$store.state.loginStatus==='login'">{{$t('lang.login.login')}}</div>
        <div class="submit pointer" @click="handleSubmit" v-else-if="$store.state.loginStatus==='register'">{{$t('lang.login.register')}}</div>
        <div class="submit pointer" @click="handleSubmit" v-else-if="$store.state.loginStatus==='forget'">{{$t('lang.login.Recover')}}</div>
        <div class="submit pointer" @click="handleSubmit" v-else-if="$store.state.loginStatus==='reset'">{{$t('lang.login.Reset')}}</div>
        <div class="submit pointer" @click="handleSubmit" v-else>{{$t('lang.login.Submit')}}</div>
      </div>
      <!--<div  v-if="$store.state.loginStatus === 'login'" class="signup-buttons">
        <div id="fb-root"></div>
        <a href="#" class="google-signup" @click.prevent="loginWithGoogle">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><title>Google</title><g fill="none" fill-rule="evenodd"><path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"></path><path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z"></path><path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.9965 8.9965 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"></path><path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"></path></g></svg>
            Google
        </a>
        <a href="#" class="facebook-signup" @click.prevent="loginWithFacebook">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#3578E5"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
            Facebook
        </a>
      </div>-->
    </div>
  </div>
</template>

<script>
import facebook from '@/assets/images/common/facebook.svg'
import google from '@/assets/images/common/google.svg'
import cancel from '@/assets/images/common/cancel_black.svg'
import triangle from '@/assets/images/common/triangle.svg'
import {fetchCurrency} from '@/constant'
import request from '@/service'
import {mapMutations} from 'vuex'
import store from '../../store/store'
import { initFbsdk } from '@/config/facebookOAuth.js'
import GoogleAuth from '@/config/googleOAuth.js'
import Vue from 'vue'

export default {
  name: 'Login',
  data () {
    return {
      cancel,
      triangle,
      facebook,
      google,
      showSelect: false,
      email: '',
      tel: '',
      sns: '',
      currency: 'USD',
      userName: '',
      // loginStatus: 'login', // login, sns, register
      password: '',
      showErr: false,
      fetchCurrency,
      emailReg: RegExp(/^(.+)@(.+)$/),
      passwordReg: RegExp(/^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*]{8,18}$/),
      currencyList: [
        // {
        //  label: 'INR ₹',
        //  value: 'INR'
        // },
        {
          label: 'USD $',
          value: 'USD'
        },
        {
          label: 'EUR €',
          value: 'EUR'
        }
        // {
        //  label: 'CNY ￥',
        //  value: 'CNY'
        // }
      ]
    }
  },
  mounted () {
  },
  methods: {
    ...mapMutations({
      setInternation: 'setInternation',
      setInternationName: 'setInternationName',
      setLocale: 'setLocale',
      setLoginStatus: 'setLoginStatus',
      toggleLogin: 'toggleLogin'
    }),

    handleSubmit () {
      console.log(' ==== handleSubmit ' + store.state.loginStatus)
      switch (store.state.loginStatus) {
        case 'login':
          this.login()
          break
        case 'register':
          this.register()
          break
        case 'forget':
          this.forgetPassword()
          break
        case 'reset':
          this.resetPassword()
          break
        case 'registerGoogle':
          this.registerGoogle()
          break
        case 'registerFacebook':
          this.registerFaceBook()
          break
      }
    },
    loginWithGoogle () {
      let that = this

      const url = '/innovation/account/getsystemsettings'
      const data = {
        FacebookId: 'GoogleClientId'
      }
      request('post', url, data).then(res => {
        const gauthOption = {
          clientId: res, // '302611557092-aisl3arsh5c9gt6o97u1hj85q0h3625j.apps.googleusercontent.com',
          scope: 'profile email',
          prompt: 'select_account'
        }
        if (!that.$gAuth || (that.$gAuth && !that.$gAuth.isInit)) {
          Vue.use(GoogleAuth, gauthOption, function (err) {
            if (!err) {
              that.toLoginGoogle(that)
            } else {
              console.log(err)
              that.$message.error(this.$t('lang.common.fail'))
            }
          })
        } else {
          that.toLoginGoogle(that)
        }
      }).catch((e) => {
        console.log(' === initLoginGoogle exception ', e)
      })
    },
    toLoginGoogle (that) {
      that.$gAuth
        .signIn()
        .then(GoogleUser => {
          console.log(' email: ' + GoogleUser.getBasicProfile().getEmail())
          that.loginWithEmail(GoogleUser.getBasicProfile().getEmail())
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    loginWithFacebook () {
      const url = '/innovation/account/getsystemsettings'
      const data = {
        FacebookId: 'FacebookAppId'
      }
      request('post', url, data).then(res => {
        initFbsdk(res)

        window.FB.login(response => {
          if (response && response.authResponse) {
            console.log(' === face book response.authResponse.userID: ' + response.authResponse.userID)
            this.loginWithFacebookId(response.authResponse.userID)
          }
        }, this.params)
      }).catch((e) => {
        console.log(' === GoogleClientId exception ', e)
      })
    },
    /****
     * 2021-09-20 LUC Google登录成功后自动登录
     */
    loginWithEmail (email) {
      const url = '/innovation/account/loginwithemail'
      const data = {
        email: email
      }
      request('post', url, data).then(res => {
        console.log(' ==== loginwithemail ==  ', res)
        if (res.Code === 1) {
          localStorage.setItem('userInfo', JSON.stringify({
            ...res
          }))
          this.toggleLogin(false)

          this.setInternation(res.Internation)
          this.setInternationName(res.InternationName)
          this.setLocale(res.Locale)
          this.$i18n.locale = res.Locale // 设置语言

          this.$router.go(0)
        } else {
          localStorage.setItem('googleloginemail', email)
          store.state.loginStatus = 'registerGoogle'
        }
      }).catch(err => {
        console.log(err)
        this.$message.error(this.$t('lang.common.fail'))
      })
    },
    /****
     * 2021-09-20 LUC Google登录成功后自动登录
     */
    loginWithFacebookId (FacebookId) {
      const url = '/innovation/account/loginwithfacebookid'
      const data = {
        FacebookId: FacebookId
      }
      request('post', url, data).then(res => {
        console.log(' ==== loginWithFacebookId ==  ', res)
        if (res.Code === 1) {
          localStorage.setItem('userInfo', JSON.stringify({
            ...res
          }))
          this.toggleLogin(false)

          this.setInternation(res.Internation)
          this.setInternationName(res.InternationName)
          this.setLocale(res.Locale)
          this.$i18n.locale = res.Locale // 设置语言

          this.$router.go(0)
        } else {
          localStorage.setItem('FacebookId', FacebookId)
          // this.setLoginStatus( 'registerGoogle' );
          store.state.loginStatus = 'registerFacebook'
        }
      }).catch(() => {
        this.$message.error(this.$t('lang.common.fail'))
      })
    },
    getSns () {
      const url = '/innovation/account/sendsnstoemail'
      const data = {
        email: this.email
      }
      request('post', url, data).then(res => {
        this.loginStatus = 'sns'
        this.sns = res.CodeForTestOnly // todo test
      }).catch(() => {
        this.$message.error(this.$t('lang.common.fail'))
      })
    },
    login () {
      if (!this.email) {
        this.$message.error(this.$t('lang.message.inputEmail'))
        return
      }
      if (!this.password) {
        this.$message.error(this.$t('lang.message.inputPassword'))
        return
      }
      if (!this.emailReg.test(this.email)) {
        this.$message.error(this.$t('lang.message.inputValid'))
        return
      }
      if (!this.passwordReg.test(this.password)) {
        this.$message.error(this.$t('lang.message.passwordMust'))
        return
      }

      const url = '/innovation/account/loginemail'
      const data = {
        email: this.email,
        password: this.password
      }
      request('post', url, data).then(res => {
        console.log(res)
        if (res.Code === 1) {
          localStorage.setItem('userInfo', JSON.stringify({
            ...res
          }))
          this.toggleLogin(false)

          this.setInternation(res.Internation)
          this.setInternationName(res.InternationName)
          this.setLocale(res.Locale)
          this.$i18n.locale = res.Locale

          this.$router.go(0)
        } else {
          switch (res.Code) {
            case 2:
              this.$message.error(this.$t('lang.message.notRegister'))
              break
            case 3:
              this.$message.error(this.$t('lang.message.notCorrect'))
              break
          }
        }
      }).catch(err => {
        console.log(err)
        this.showErr = true
        this.$message.error(this.$t('lang.common.fail'))
      })
    },
    register () {
      if (!this.email) {
        this.$message.error(this.$t('lang.message.inputEmail'))
        return
      }
      if (!this.userName) {
        this.$message.error(this.$t('lang.message.inputUsername'))
        return
      }
      if (!this.password) {
        this.$message.error(this.$t('lang.message.inputPassword'))
        return
      }
      if (!this.emailReg.test(this.email)) {
        this.$message.error(this.$t('lang.message.inputValid'))
        return
      }
      if (!this.passwordReg.test(this.password)) {
        this.$message.error(this.$t('lang.message.passwordMust'))
        return
      }

      const url = '/innovation/account/registerinternation'
      const data = {
        email: this.email,
        userName: this.userName,
        password: this.password,
        currencyName: this.currency,
        campaignId: localStorage.getItem('cid'),
        internation: this.$store.state.internation
      }
      request('post', url, data).then(res => {
        console.log(res)
        if (res.Code === 0) {
          localStorage.setItem('userInfo', JSON.stringify({...res}))
          this.$message.info(this.$t('lang.message.registerSuccess'))
          this.toggleLogin(false)
          this.$router.go(0)
          /* setTimeout(() => {
            this.$router.push({path: '/home', query: {}})
          }, 2000) */
        } else if (res.Code === 10000) {
          this.$message.warning(this.$t('lang.message.usernameExit'))
        } else if (res.Code === 10004) {
          this.$message.warning(this.$t('lang.message.emailExit'))
        } else if (res.Code === 10003) {
          this.$message.warning(this.$t('lang.message.accountSuspended'))
        } else if (res.Code === -1) {
          this.$message.warning(this.$t('lang.message.registerFail'))
        }
      }).catch((err) => {
        console.log(err)
        this.$message.error(this.$t('lang.message.registerFail'))
      })
    },
    /****
     * 2021-10-XX LUC 谷歌注册
     */
    registerGoogle () {
      let email = localStorage.getItem('googleloginemail')
      const url = '/innovation/account/registerfromgoogle'
      const data = {
        email: email,
        // countryCode: this.countryCode,
        userName: this.userName,
        currencyName: this.currency,
        campaignId: localStorage.getItem('cid'),
        internation: this.$store.state.internation
      }
      request('post', url, data).then(res => {
        console.log(res)

        if (res.Code === 0) {
          localStorage.setItem('userInfo', JSON.stringify({...res}))
          this.$message.info(this.$t('lang.message.registerSuccess'))
          this.toggleLogin(false)
          // this.$router.go(0)
          setTimeout(() => {
            this.$router.push({path: '/home', query: {}})
          }, 2000)
          this.$router.go(0)
        } else if (res.Code === 10000) {
          this.$message.error(this.$t('lang.message.usernameExit'))
        } else if (res.Code === 10001) {
          this.$message.error(this.$t('lang.message.mobileExit'))
        } else {
          this.$message.error(this.$t('lang.message.registerFail'))
        }
      }).catch(() => {
        this.$message.error(this.$t('lang.common.fail'))
      })
    },
    /****
     * 2021-10-XX LUC Facebook注册
     */
    registerFaceBook () {
      console.log(' ==== registerfromfacebook*** ')
      let FacebookId = localStorage.getItem('FacebookId')
      const url = '/innovation/account/registerfromfacebook'
      const data = {
        FacebookId: FacebookId,
        // countryCode: this.countryCode,
        userName: this.userName,
        currencyName: this.currency,
        campaignId: localStorage.getItem('cid'),
        internation: this.$store.state.internation
      }
      request('post', url, data).then(res => {
        console.log(res)

        if (res.Code === 0) {
          localStorage.setItem('userInfo', JSON.stringify({...res}))
          this.$message.info(this.$t('lang.message.registerSuccess'))
          this.toggleLogin(false)
          // this.$router.go(0)
          setTimeout(() => {
            this.$router.push({path: '/home', query: {}})
          }, 2000)
          this.$router.go(0)
        } else if (res.Code === 10000) {
          this.$message.error(this.$t('lang.message.usernameExit'))
        } else if (res.Code === 10001) {
          this.$message.error(this.$t('lang.message.mobileExit'))
        } else {
          this.$message.error(this.$t('lang.message.registerFail'))
        }
      }).catch(() => {
        this.$message.error(this.$t('lang.common.fail'))
      })
    },
    forgetPassword () {
      if (!this.email) {
        this.$message.error(this.$t('lang.message.inputEmail'))
        return
      }
      if (!this.emailReg.test(this.email)) {
        this.$message.error(this.$t('lang.message.inputValid'))
        return
      }
      const url = '/innovation/account/forgetpassword'
      const data = {
        email: this.email,
        campaignId: localStorage.getItem('cid')
      }
      request('post', url, data).then(res => {
        console.log(res)
        this.$message.info(res.retMsg)
      }).catch((err) => {
        console.log(err)
        this.$message.error(this.$t('lang.message.registerFail'))
      })
    },
    resetPassword () {
      if (!this.password) {
        this.$message.error(this.$t('lang.message.inputPassword'))
        return
      }
      if (!this.passwordReg.test(this.password)) {
        this.$message.error(this.$t('lang.message.passwordMust'))
        return
      }

      const url = '/innovation/account/resetpassword'
      const data = {
        activeCode: this.$route.query.rv,
        password: this.password,
        campaignId: localStorage.getItem('cid')
      }
      request('post', url, data).then(res => {
        console.log(res)
        this.$message.info(res.retMsg)
        setTimeout(() => {
          this.$router.push({path: '/home', query: {}})
        }, 2000)
      }).catch((err) => {
        console.log(err)
        this.$message.error(this.$t('lang.message.registerFail'))
      })
    },
    select (type, val) {
      this[type] = val
      this.showSelect = false
    },
    close () {
      this.$parent.close()
    }
  }
}
</script>

<style lang="less" scoped>
  .loginContainer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.8);
    z-index: 10;
    .loginContent {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      >img {
        position: absolute;
        top: -28px;
        right: -28px;
        width: 28px;
      }
      .signup-buttons {
        margin-top: 15px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        position: relative;
      }

      .fg-login-option{
        .prompt{
          text-align: center;
          margin-bottom: 15px;
        }

        .login-option{
          display: flex;
          .option-item{
            color: #F6D9AA;
            font-size: 14px;
          }
          .splitter{
            padding-right: 10px;
            border-right: 1px solid #F6D9AA;
          }
          .pd-left {
            padding-left: 10px;
          }
          .login-option-item{
            flex: 1;
            text-align: center;
            padding: 5px 0px;
            img{
              width: 25px;
              height: 25px;
              margin: 0 auto;
            }
          }
        }
      }

      .facebook-signup, .google-signup {
          color: #031b4e;
          background: #f2f8ff;
          border: 1px solid rgba(0,105,255,.2);
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          border-radius: 3px;
          display: inline-block;
          margin-top: 0;
          width: 47.5%;
          padding: 15px;
          text-align: center;
          position: inherit;
      }
      .signup-buttons a {
          vertical-align: middle;
          text-decoration: none;
      }
      .signup-buttons svg {
          left: 16px;
          position: absolute;
          top: 50%;
          -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
      }
      .title {
        font-size: 34px;
        line-height: 55px;
        font-weight: bold;
        color: #543200;
        text-align: center;
        background: #F6D9AA;
        border-radius: 10px 10px 0 0;
      }
      .body {
        width: 520px;
        /*height: 220px;*/
        padding: 33px 55px 40px;
        margin-bottom: 40px;
        background: #212324;
        border-radius: 0 0 10px 10px;
        .text1 {
          font-size: 18px;
          line-height: 21px;
          color: #F6D9AA;
        }

        .text2 {
          font-size: 14px;
          line-height: 24px;
          color: #F6D9AA;
        }
        .text3 {
          font-size: 12px;
          line-height: 14px;
          color: #F6D9AA;
        }
        .textErr {
          margin-top: 10px;
          font-size: 16px;
          line-height: 19px;
          color: #f00;
        }
        .inputRow {
          display: flex;
          height: 40px;
          .selectInput {
            text-align: center;
            height: 40px;
            line-height: 40px;
            border: 1px solid rgba(246, 217, 170, 0.5);
            color: #666;
          }
          .select, input {
            /*height: 100%;*/
            padding: 0 10px;
            font-size: 16px;
            line-height: 40px;
            color: #ffffff;
            text-align: left;
            letter-spacing: 0.1em;
            border: 1px solid rgba(246, 217, 170, 0.5);
            &:first-child {
              flex: 1;
              margin-right: 20px;
            }
            &:last-child {
              flex: 2;
              margin-right: 0;
            }
          }

          .select {
            position: relative;
            display: flex;
            align-items: center;
            >div:first-child {
              position: absolute;
              left: 0;
              top: -20px;
            }
            .input {
              /*height: 100%;*/
              flex: 1;
            }
            img {
              height: 14px;
              width: 12px;
              margin-right: 10px;
              transition: transform .3s;
              /*position: absolute;*/
              /*top: 50%;*/
              /*transform: translateY(-50%);*/
              /*right: 15px;*/
            }
            .selectList {
              position: absolute;
              left: 0;
              top: 50px;
              padding: 15px 0;
              width: max-content;
              text-align: left;
              background: #202020;
              border: 1px solid rgba(246, 217, 170, 0.5);
              border-radius: 0 0 10px 10px;
              cursor: default;
              .option {
                padding: 0 15px;
                line-height: 30px;
                &:hover {
                  background: #333;
                }
              }
            }
            .rotate {
              transform: translateY(-50%);
              transform: rotate(90deg);
            }
          }
        }
        .footer-operation{
          display: flex;

          .operation-item{
            font-size: 16px;
            line-height: 25px;
            height: 25px;
          }

          .operation-item:hover{
            text-decoration: underline;
          }

          .splitter{
            border-right: 1px solid #686868;
            width: 1px;
            height: 15px;
            margin: 5px 20px;
            box-sizing: border-box;
          }
        }
      }
      .submit {
        float: right;
        width: 200px;
        height: 50px;
        font-size: 22px;
        line-height: 50px;
        color: #000;
        text-align: center;
        background: #F6D9AA;
        box-shadow: 0 5px 10px rgba(255, 176, 48, 0.61);
        border-radius: 6px;
      }
    }
    .mb40 {
      margin-bottom: 40px;
    }
    .mb15 {
      margin-bottom: 15px;
    }
    .mb25 {
      margin-bottom: 25px;
    }
    .mt15{
      margin-top: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginEmail/index.vue